<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.dt_ultima_ficha="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Data da última atualização e percentual de completude do Cadastro Individual (CI) do cidadão"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.dt_ultima_fcd="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Data da última atualização e percentual de completude do Cadastro Domiciliar e Territorial (CDT) do cidadão"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.id="{ item }">
            {{ item.id == null ? item.nu_cpf_cns : item.id }}
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            <div>
              {{ formatDate(item.dt_nascimento) }}
              <br />
              ({{ item.idade }} {{ item.idade > 1 ? 'anos' : 'ano' }})
            </div>
          </template>
          <template v-slot:item.dt_ultima_ficha="{ item }">
            <span
              v-if="item.dt_ultima_ficha != null"
              class="card-table-span-date"
            >
              {{ formatDate(item.dt_ultima_ficha) }}<br />
              ({{ verificaTempo(item.dt_ultima_ficha) }})
            </span>
          </template>
          <template v-slot:item.percent_fci_completa="{ item }"
            >{{
              item.percent_fci_completa ? item.percent_fci_completa + '%' : '0%'
            }}
          </template>

          <template v-slot:item.dt_ultima_fcd="{ item }">
            <span
              v-if="item.dt_ultima_fcd != null"
              class="card-table-span-date"
            >
              {{ formatDate(item.dt_ultima_fcd) }}<br />
              ({{ verificaTempo(item.dt_ultima_fcd) }})
            </span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table
                class="table table-interna table-interna-cadastros-cidadaos"
              >
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Endereço</th>
                    <th>Saiu?</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                    <th v-if="exibirCopilot">Suporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.nu_cpf }}
                    </td>
                    <td>
                      {{ item.nu_cns }}
                    </td>
                    <td>{{ item.endereco }}</td>
                    <td>{{ item.saiu == '2' ? 'Sim' : '' }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                class="table table-interna table-interna-cadastros-cidadaos"
              >
                <thead>
                  <tr>
                    <th>Campos do Cadastro individual ainda não preenchidos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="item.fci_completa == null">
                      Após o preenchimento da ficha simplificada do cidadão,
                      recomenda-se preencher também o Cadastro Individual (CI)
                      completo. Isso garante a qualidade, completude e
                      integridade do cadastro.
                    </td>
                    <td v-else-if="parseInt(item.percent_fci_completa) >= 100">
                      Parabéns &#128079; CI completo.
                    </td>
                    <td v-else>
                      {{ item.fci_completa.replace(/^\{|\}$/g, '') }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                class="table table-interna table-interna-cadastros-cidadaos"
              >
                <thead>
                  <tr>
                    <th>Campos do Cadastro domiciliar ainda não preenchidos</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-if="item.fcdt_completa == null">
                      Após o preenchimento da ficha simplificada do cidadão,
                      recomenda-se preencher também o Cadastro Domiciliar e
                      Territorial (CDT) completo. Isso garante a qualidade,
                      completude e integridade do cadastro.
                    </td>
                    <td v-else-if="parseInt(item.percent_fcdt_completa) >= 100">
                      Parabéns &#128079; CDT completo.
                    </td>
                    <td v-else>
                      {{ item.fcdt_completa.replace(/^\{|\}$/g, '') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from './copilot.js'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },

        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'CI',
          align: 'start',
          filterable: false,
          value: 'dt_ultima_ficha',
          width: '150px',
        },
        {
          text: 'CDT',
          align: 'start',
          filterable: false,
          value: 'dt_ultima_fcd',
          width: '150px',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
    },
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    ultimaAtualizacaoSincronizadorC() {
      return this.$store.state.sincronizadorC.ultimaAtualizacao
        .split('/')
        .reverse()
        .join('-')
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${this.printTableRow(item)}`
    },

    printTableRow(item) {
      return Functions.printTableRow(item)
    },

    diffDates(date) {
      if (date !== null) {
        return this.differenceOfDaysBetweenTwoDates(
          date,
          this.ultimaAtualizacaoSincronizadorC.split('/').reverse().join('-')
        )
      }
    },

    verificaTempo(value) {
      if (value != null) {
        let dias = this.diffDates(value)
        if (dias <= 31) {
          return dias + ' dias'
        } else {
          let meses = Math.floor(dias / 30)
          return meses == 1 ? `${meses} mês` : `${meses} meses`
        }
      } else {
        return ''
      }
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },
  },
}
</script>

<style>
.tabela .green-color {
  color: green !important;
}
.tabela .red-color {
  color: red !important;
}
</style>
<style scoped lang="scss"></style>
